module.exports = __webpack_public_path__ + "static/logo_gold.742690cd.png";